import type { EditorBlockGroup, IconItem } from 'types/section'

// Blocks of the page editor that customers can use today (app/editor/components)
export const editorBlockGroups: EditorBlockGroup[] = [
  {
    slug: 'medias',
    kicker: 'Vidéos et images',
    title: 'Des pages vivantes qui attirent le regard',
    description: 'Le mouvement capte l\'attention bien mieux qu\'une affiche. Mélangez vidéos, images et diaporamas en quelques clics.',
    items: [
      {
        iconName: 'ph:youtube-logo-duotone',
        title: 'Vidéos YouTube et Vimeo',
        description: 'Diffusez les vidéos que vous publiez déjà en ligne, sans les télécharger ni les convertir.'
      },
      {
        iconName: 'ph:images-duotone',
        title: 'Défilement d\'images',
        description: 'Plusieurs photos se succèdent dans un même emplacement, à la durée de votre choix.'
      },
      {
        iconName: 'ph:stack-duotone',
        title: 'Diaporama dans la page',
        description: 'Intégrez un autre diaporama dans une page, par exemple vos offres du moment, partout à la fois.'
      }
    ]
  },
  {
    slug: 'animations',
    kicker: 'Animations et mise en page',
    title: 'Un rendu soigné, sans être graphiste',
    description: 'Animez chaque élément et placez-le exactement où vous le voulez : vos pages gardent une allure professionnelle.',
    items: [
      {
        iconName: 'ph:sparkle-duotone',
        title: 'Animations d\'entrée et de sortie',
        description: 'Fondu, glissement ou machine à écrire : faites apparaître chaque élément avec style.'
      },
      {
        iconName: 'ph:shapes-duotone',
        title: 'Formes et couleurs',
        description: 'Des formes colorées pour structurer vos pages et mettre en valeur vos messages clés.'
      },
      {
        iconName: 'ph:crosshair-simple-duotone',
        title: 'Placement précis',
        description: 'Placez chaque élément exactement où vous le voulez, au pourcentage près, sur tous vos écrans.'
      }
    ]
  },
  {
    slug: 'engagement',
    kicker: 'Promotions et interaction',
    title: 'Des écrans qui donnent envie d\'agir',
    description: 'Créez l\'urgence autour d\'une offre et prolongez la visite sur le téléphone de vos clients.',
    items: [
      {
        iconName: 'ph:hourglass-duotone',
        title: 'Compte à rebours',
        description: 'Jours, heures et minutes avant une promotion, une ouverture ou un événement, en direct.'
      },
      {
        iconName: 'ph:qr-code-duotone',
        title: 'QR code',
        description: 'Un code à scanner vers votre site, votre menu, votre numéro de téléphone ou votre email.'
      },
      {
        iconName: 'ph:browser-duotone',
        title: 'Page web intégrée',
        description: 'Affichez une page de votre site ou d\'un service en ligne, directement sur l\'écran.'
      }
    ]
  },
  {
    slug: 'infos-pratiques',
    kicker: 'Infos pratiques',
    title: 'L\'heure, la date et la météo, toujours exactes',
    description: 'Des informations du quotidien qui se mettent à jour toutes seules sur chacun de vos écrans.',
    items: [
      {
        iconName: 'ph:clock-duotone',
        title: 'Horloge',
        description: 'L\'heure en direct, en chiffres ou en tuiles, aux couleurs de votre établissement.'
      },
      {
        iconName: 'ph:calendar-blank-duotone',
        title: 'Date du jour',
        description: 'Le jour et la date en toutes lettres, en chiffres ou façon calendrier, toujours à jour.'
      },
      {
        iconName: 'ph:cloud-sun-duotone',
        title: 'Météo',
        description: 'Les prévisions de votre ville sur un à trois jours : température, vent et précipitations.'
      }
    ]
  }
]

// Ideas built on request: never presented as available today
export const editorOnDemandBlocks: IconItem[] = [
  {
    iconName: 'ph:share-network-duotone',
    title: 'Réseaux sociaux',
    description: 'Vos dernières publications Instagram, Facebook ou LinkedIn, affichées automatiquement.'
  },
  {
    iconName: 'ph:calendar-dots-duotone',
    title: 'Agenda d\'événements',
    description: 'Votre programme ou vos réservations, repris d\'un calendrier en ligne et toujours à jour.'
  },
  {
    iconName: 'ph:map-trifold-duotone',
    title: 'Carte et plan d\'accès',
    description: 'Une carte pour guider vos visiteurs jusqu\'à vous, ou à travers vos locaux et vos étages.'
  },
  {
    iconName: 'ph:train-duotone',
    title: 'Horaires des transports',
    description: 'Les prochains départs de bus et de trains depuis l\'arrêt le plus proche de chez vous.'
  },
  {
    iconName: 'ph:newspaper-duotone',
    title: 'Actualités',
    description: 'Les dernières nouvelles de votre site ou de votre blog, reprises automatiquement à l\'écran.'
  },
  {
    iconName: 'ph:chart-line-up-duotone',
    title: 'Chiffres clés',
    description: 'Vos indicateurs, objectifs ou résultats du jour, affichés en direct pour vos équipes.'
  }
]
